import { Component } from '@theme/component';

/**
 * A custom element that truncates text content
 *
 * @typedef {object} Refs
 * @property {HTMLElement} textExpandMoreWrapper - Wrapper element to truncate
 * @property {HTMLElement} textExpandMoreButton - Button element to toggle the truncation
 *
 * @extends {Component<Refs>}
 */
export class TextExpandMore extends Component {
  requiredRefs = ['textExpandMoreWrapper', 'textExpandMoreButton'];

  connectedCallback() {
    super.connectedCallback();

    const { textExpandMoreButton } = this.refs;

    if (textExpandMoreButton) {
      textExpandMoreButton.addEventListener('click', this.#handleClickExpand.bind(this));
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const { textExpandMoreButton } = this.refs;

    textExpandMoreButton?.removeEventListener('click', this.#handleClickExpand.bind(this));
  }

  #handleClickExpand() {
    const { textExpandMoreButton } = this.refs;
    this.setAttribute('expanded', '');

    textExpandMoreButton.setAttribute('aria-expanded', 'true')
  }
}

if (!customElements.get('text-expand-more')) {
  customElements.define('text-expand-more', TextExpandMore);
}
